<template>
  <div class="row list-unstyled c-mb-0">
    <a
      style="margin: 0;line-height: 1;padding: 0;text-decoration: none;"
      href="https://anpc.ro/ce-este-sal/"
      target="_blank"
      rel="nofollow"
    >
      <img
        style="display:inline-block;border:0;width:250px;margin:5px;"
        src="https://etamade-com.github.io/anpc-sal-sol-logo/anpc-sal.svg"
        alt="Solutionarea Alternativa a Litigiilor"
      >
    </a>
    <a
      style="margin: 0;line-height: 1;padding: 0;text-decoration: none;"
      href="https://ec.europa.eu/consumers/odr"
      target="_blank"
      rel="nofollow"
    >
      <img
        style="display:inline-block;border:0;width:250px;margin:5px;"
        src="https://etamade-com.github.io/anpc-sal-sol-logo/anpc-sol.svg"
        alt="Solutionarea Online a Litigiilor"
      >
    </a>
  </div>
</template>
